import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import Icon from 'discada/dist/Icon'
import { addToPageState } from 'actions/pageStateActions'

import { getOptionCodeSet } from 'selectors/quoteSelectors'

import './DealRoad.scss'

const ICONS = {
  fandi: 'map',
  info: 'info',
  trades: 'car',
  rebates: 'file-invoice-dollar',
  presentation: 'mobile-alt',
  programs: 'university',
  contract: 'file-contract',
  customer: 'user-circle',
  interactions: 'lightbulb',
}

const LABELS = {
  fandi: 'F&I',
  info: 'History',
  trades: 'Trades',
  rebates: 'Rebates & Cash',
  presentation: 'Presentation',
  programs: 'All Programs',
  contract: 'Summary',
  customer: 'Customer',
  interactions: 'Illuminate',
}

export function DealRoadSection(props) {
  let {
      className,
      section,
      activeSection,
      addToPageState,
      frikinIcon,
      disabled,
    } = props,
    isActive = section === activeSection,
    setActiveSection = () =>
      !disabled && addToPageState({ 'dealtuner.section': section })

  return (
    <div
      className={c(
        'deal-road-section',
        `deal-road-section-${section}`,
        className,
        {
          'deal-road-section-active': isActive,
          'deal-road-section-disabled': disabled,
        },
      )}
      onClick={setActiveSection}
    >
      <div className="deal-road-icon">
        <Icon icon={ICONS[section]} frikin={frikinIcon} />
      </div>
      <div className="deal-road-label">{LABELS[section]}</div>
    </div>
  )
}

export function DealRoad(props) {
  let { className, activeSection, hasOptionCodes } = props

  return (
    <div className={c('deal-road', className, `deal-road-${activeSection}`)}>
      <hr />

      <div className="deal-road-group">
        <DealRoadSection {...props} section="fandi" />
        <DealRoadSection {...props} section="trades" />
        <DealRoadSection
          {...props}
          section="rebates"
          className={hasOptionCodes ? 'deal-road-section-highlight' : null}
        />
        <DealRoadSection {...props} section="presentation" />
        <DealRoadSection {...props} section="programs" />
        <DealRoadSection {...props} section="contract" />
        <DealRoadSection {...props} section="interactions" />
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    hasOptionCodes: !isEmpty(getOptionCodeSet(state, op.vehicleId, op.quoteId)),
  }
}

export default connect(
  mapStateToProps,
  { addToPageState },
)(DealRoad)
